import Mmenu from "mmenu-js";

document.addEventListener("DOMContentLoaded", () => {
  new Mmenu("#zonecollege-mmenu", {
    extensions: ["theme-white", "pagedim-black", "fx-menu-slide"],
    navbar: {
      title:
        "<img src='/wp-content/themes/zone-college/images/expedition/logo-zone.svg' width='100'>"
    }
  });
});
